import Empty from "@/components/Empty.tsx";
import {Box, Stack, Typography, Chip, Button, Divider, useTheme} from '@mui/material'
import LoadMore from "@/components/LoadMore";
import RpIcon from "@/components/RpIcon";
import TransItem from "@/components/skeleton/TransItem";
import API from "@/constant/API";
import RouteConstant from "@/constant/RouteConstant";
import useLoadMore from "@/hook/useLoadMore";
import useRenders from "@/hook/useRenders";
import axiosInstance from "@/utils/axios";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import DayAssetsTransItem from "./DayAssetsTransItem";
import AssetsTransItem from "./AssetsTransItem.tsx";
import AssetsTransDetail from "./AssetsTransDetail";
import SearchItem from "@/pages/components/SearchItem"
import useSettings from "@/hook/useSettings";
import {useMemo, useRef} from "react";
import {groupBy} from 'es-toolkit/array';
import dayjs from 'dayjs';
import {useInfiniteScroll} from 'ahooks'
import classes from './index.module.css'
import PageBack from "@/components/PageBack";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";

interface Props {
  isCompact: boolean;
  bussinessType?: number;
  pageable?: boolean;
}

export default function AssetsTransactions({pageable, isCompact = false, bussinessType}) {
  const {t} = useTranslation();
  const navigate = useNavigate();

  const {
    settings,
  } = useSettings();

  const {renderDate} = useRenders();
  const theme = useTheme();
  const ref = useRef(null);
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [hasMore, setHasMore] = useState(false);
  const [current, setCurrent] = useState(null);
  const [search, setSearch] = useState(false);

  const [filters, setFilters] = useState([]);

  const _toTransList = () => {
    navigate(`${RouteConstant.ASSETS_TRANS_LIST}?bussinessType=${bussinessType}`);
  }

  const wrapperRef = useRef(null);

  const getList = async (pageNum: number, values: any) => {
    let res = await axiosInstance.post(API.WITHDRAW_LIST, {
      pageNum, pageSize: pageSize, ...values
    });

    const result = {
      list: res?.list || [],
      total: res?.total || 0,
      page: pageNum,
    };
    return result;
  }

  const getCompactList = async (pageNum: number) => {
    const res = await getList(1, {})
    return res?.list || []
  }

  const {data, loading, loadMore, loadingMore, noMore, reload, reloadAsync} = useInfiniteScroll((d) => {
    const page = d ? d.page + 1 : 1
    return getList(page, filters);
  }, {
    manual: true,
    target: isCompact ? null : ref,
    threshold: 300,
    isNoMore: (d) => {
      // d?.total <= d.list.length,
      return (d && d.list.length >= d.total)
    },
  });

  const handleSearch = (values) => {
    if (values.daysLasting === 'customize') {
      const startTime = renderDate(values.startTime)
      const endTime = renderDate(values.endTime)
      delete values.daysLasting;
      values = {...values, startTime, endTime};

    } else if (values.daysLasting === 'all') {
      values = {};
    } else {
      delete values.startTime;
      delete values.endTime;
    }
    setFilters(values)
    // loadMore(pageNum, pageSize, values);
    setSearch(false)
  }

  useEffect(() => {
    reloadAsync()
  }, [filters]);

  const list = useMemo(() => {
    if (!data) return [];
    return isCompact ? data.list.slice(0, 3) : data.list;
  }, [data]);

  const groupedList = useMemo(() => {
    const result = groupBy(list, (item) => {
      return dayjs(item.createTime).format('YYYYMMDD')
    })
    return result
  }, [list])

  return (
    <Stack
      className={classes.root}>
      <SimpleHeader
        backEnable
        title={t('withdraw_list')}
      />
      <Stack direction="column" sx={{flex: 1, overflow: 'auto'}} ref={ref}>
        {loading ? (
          <Stack sx={{padding: '16px'}}>
            <TransItem/>
            <TransItem/>
            <TransItem/>
          </Stack>
        ) : list.length === 0 ? (
          <Box>
            <Empty text={t("empty_data")}/>
          </Box>
        ) : (
          <>
            <Box ref={wrapperRef}>
                  {list.map((item) => (
                    <AssetsTransItem
                      record={item}
                      key={item.createTime}
                      onClick={() => {
                        setCurrent(item);
                        navigate(`${RouteConstant.WITHDRAW_DETAIL}?sn=${item.sn}`);
                      }}
                    />
                  ))}
              {/*{Object.keys(groupedList).map((date,index) => (<>*/}
              {/*  {index !== 0 && <Divider sx={{ borderColor: theme.palette.background.paper, borderWidth: '4px' }} />}*/}
              {/*  <Box key={date}>*/}
              {/*    <Box className={'small'} sx={{padding:"16px 16px 0"}}>{date}</Box>*/}
              {/*    /!*{groupedList[date].map((item) => (*!/*/}
              {/*    /!*  <AssetsTransItem*!/*/}
              {/*    /!*    record={item}*!/*/}
              {/*    /!*    key={item.createTime}*!/*/}
              {/*    /!*    onClick={() => {*!/*/}
              {/*    /!*      setCurrent(item);*!/*/}
              {/*    /!*      navigate(`${RouteConstant.WITHDRAW_DETAIL}?sn=${item.sn}`);*!/*/}
              {/*    /!*    }}*!/*/}
              {/*    /!*  />*!/*/}
              {/*    /!*))}*!/*/}
              {/*    {list.map((item) => (*/}
              {/*      <AssetsTransItem*/}
              {/*        record={item}*/}
              {/*        key={item.createTime}*/}
              {/*        onClick={() => {*/}
              {/*          setCurrent(item);*/}
              {/*          navigate(`${RouteConstant.WITHDRAW_DETAIL}?sn=${item.sn}`);*/}
              {/*        }}*/}
              {/*      />*/}
              {/*    ))}*/}
              {/*  </Box>*/}
              {/*</>))}*/}
            </Box>
            <Box style={{marginTop: 8}}>
              {(!isCompact && !loading && !noMore) && (
                <Box>
                  <LoadMore disabled={loadingMore} loading={loadingMore} hasMore={!noMore} onClick={() => {
                    // loadMore()
                  }}/>
                </Box>
              )}

              {(!loading && noMore) && <Typography align="center">{t('no_more_data')}</Typography>}
            </Box>
          </>

        )}

      </Stack>
      {/*{current && <AssetsTransDetail open={current} onClose={() => setCurrent(null)} sn={current.sn}/>}*/}
      <SearchItem open={search} onClose={() => setSearch(false)} onSearch={handleSearch}></SearchItem>
    </Stack>
  );
}
